<script>
import useSharedMethod from "@/use/SharedMethod";
import {computed} from "vue";

export default {
    props: {
        pay_slip: {
            type: Object,
            required: true,
        },
        hideDetail: Boolean,
    },
    setup(props) {
        const {priceFormat} = useSharedMethod();
        
        const details = computed(() => {
            const array = [];
            props.pay_slip.details.forEach((detail) => {
                if (detail.printIn !== "5" && detail.value !== 0) {
                    array.push(detail);
                }
            });
            return array.slice().sort((a, b) => a.paySectionOrdre - b.paySectionOrdre);
        });
        
        return {
            details,
            priceFormat,
        }
    }
};
</script>

<template>
    <div>
        <v-simple-table dense v-if="!hideDetail">
            <tbody>
            <tr>
                <td style="background-color: #80cbc41a" colspan="2">
                    {{ $t('pay_slip.total_earnings') }}
                    <h2 class="teal--text">{{ priceFormat(pay_slip.totalGains) }}</h2>
                </td>
                <td style="background-color: #ef9a9a1a" colspan="2">
                    {{ $t('pay_slip.total_restraint') }}
                    <h2 class="red--text">{{ priceFormat(pay_slip.totalRetenues) }}</h2>
                </td>
                <td style="background-color: #90caf91a" colspan="2">
                    {{ $t('pay_slip.net_to_pay') }}
                    <h2 class="blue--text">{{ priceFormat(pay_slip.net) }}</h2>
                </td>
            </tr>
            </tbody>
        </v-simple-table>
        <v-simple-table
            dense
            fixed-header
            height="370"
        >
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">{{ $t('common.code') }}</th>
                    <th class="text-left">{{ $t('pay_slip.pay_section') }}</th>
                    <th class="text-left">{{ $t('pay_slip.earnings') }}</th>
                    <th class="text-left">{{ $t('pay_slip.restraint') }}</th>
                    <th class="text-left">{{ $t('pay_slip.base') }}</th>
                    <th class="text-left">{{ $t('pay_slip.rate') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(v, i) in details" :key="i">
                    <td :style="v.printIn === '4' ? 'color: red;' : ''">
                        <w-tooltip
                            :label="v.code"
                            :tooltip="v.formule"
                        />
                    </td>
                    <td :style="v.printIn === '4' ? 'color: red;' : ''">
                        {{ v.label }}
                    </td>
                    <td style="color: green">
                        <div v-if="v.printIn === '3'">
                            {{ priceFormat(v.value) }}
                        </div>
                    </td>
                    <td style="color: red">
                        <div v-if="v.printIn === '4'">
                            {{ priceFormat(v.value) }}
                        </div>
                    </td>
                    <td style="color: blue">
                        <div v-if="v.base !== null && v.base !== 0">
                            {{ priceFormat(v.base) }}
                        </div>
                    </td>
                    <td style="color: blue">
                        <div v-if="v.taux !== null && v.taux !== 0">
                            {{ priceFormat(v.taux) }}
                        </div>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>